import React, { Suspense } from 'react';
import { Route } from 'react-router';
import ServiceSettingContainer from '../containers/ServiceSettingContainer/ServiceSettingContainer';
import {
    analyticalDistributionService,
    billableProductService,
    chaptersBlocks,
    clinicSettingService,
    limitedServicesSettings,
    medicalPackages,
    packageListService,
    serviceCategory,
    supplementalProduct,
    productTags,
} from '../constants/constants';
import PageLoader from '../components/PageLoader/PageLoader';

const CategoryListPage = React.lazy(() => import('../pages/ServicePages/CategoryPage'));
const ChaptersBlocksListPage = React.lazy(() => import('../pages/ServicePages/ChaptersBlocksPage'));
const BillableProductsPage = React.lazy(() => import('../pages/ServicePages/BillableProductList'));
const PackageListpage = React.lazy(() => import('../pages/ServicePages/PackageListPage'));
const ClinicSettingsPage = React.lazy(() => import('../pages/ServicePages/ClinicSettingsPage'));
const AnalyticalDistributionPage = React.lazy(() => import('../pages/ServicePages/AnalyticalDistributionPage'));
const LimitedServicesSettingContainer = React.lazy(() => import('../pages/LimitedServicesSettingPage/LimitedServicesSettingPage'));
const MedicalPackagesSettingsPage = React.lazy(() => import('../pages/MedicalPackagesSettingsPage/MedicalPackagesSettingsPage'));
const SupplementalProductSettingsPage = React.lazy(() => import('../pages/ServicePages/SupplementalProductSettingsPage'));
const ProductTagsPage = React.lazy(() => import('../pages/ServicePages/ProductTagsPage'));

const ServiceSettingRoutes = props => (
    <ServiceSettingContainer {...props}>
        <Suspense fallback={<PageLoader />}>
            <Route path={serviceCategory} exact component={CategoryListPage} />
            <Route path={chaptersBlocks} exact component={ChaptersBlocksListPage} />
            <Route path={billableProductService} exact component={BillableProductsPage} />
            <Route path={packageListService} exact component={PackageListpage} />
            <Route path={clinicSettingService} exact component={ClinicSettingsPage} />
            <Route path={analyticalDistributionService} exact component={AnalyticalDistributionPage} />
            <Route path={limitedServicesSettings} exact component={LimitedServicesSettingContainer} />
            <Route path={medicalPackages} exact component={MedicalPackagesSettingsPage} />
            <Route path={supplementalProduct} exact component={SupplementalProductSettingsPage} />
            <Route path={productTags} exact component={ProductTagsPage} />
        </Suspense>
    </ServiceSettingContainer>
);

export default ServiceSettingRoutes;
